import { render, staticRenderFns } from "./PFCore.vue?vue&type=template&id=2d6e3a40"
import script from "./PFCore.vue?vue&type=script&lang=js"
export * from "./PFCore.vue?vue&type=script&lang=js"
import style0 from "./PFCore.vue?vue&type=style&index=0&id=2d6e3a40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports